import { SVGProps } from 'react';

const SvgHubSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M8.5 4a.5.5 0 0 0-1 0v2.793L5.354 4.646a.5.5 0 0 0-.708.708L6.793 7.5H4a.5.5 0 0 0 0 1h2.793l-2.146 2.146a.5.5 0 0 0 .707.707L7.5 9.207V12a.5.5 0 0 0 1 0V9.208l2.146 2.146a.5.5 0 1 0 .707-.707L9.207 8.5H12a.5.5 0 0 0 0-1H9.208l2.146-2.146a.5.5 0 1 0-.707-.708L8.5 6.793V4ZM.5 2A1.5 1.5 0 0 1 2 .5h1.5a.5.5 0 0 1 0 1H2a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 1-1 0V2ZM15.5 14a1.5 1.5 0 0 1-1.5 1.5h-1.5a.5.5 0 0 1 0-1H14a.5.5 0 0 0 .5-.5v-1.5a.5.5 0 0 1 1 0V14ZM14 .5A1.5 1.5 0 0 1 15.5 2v1.5a.5.5 0 0 1-1 0V2a.5.5 0 0 0-.5-.5h-1.5a.5.5 0 0 1 0-1H14ZM2 15.5A1.5 1.5 0 0 1 .5 14v-1.5a.5.5 0 0 1 1 0V14a.5.5 0 0 0 .5.5h1.5a.5.5 0 0 1 0 1H2Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgHubSmall;
